import { http } from '../../axios';
import { shopPrefix } from '../../../config';
import { BulkAddProductsToSelectionListResponse } from '../../../store/api';

export const addRenewalsToSelectionList = (selectionListId: string, totalValue: number, performChecks: boolean) => {
    return http
        .post<BulkAddProductsToSelectionListResponse>(
            `${shopPrefix}/v2/selectionlists/:selectionListId/bulk/renewals/add`,
            { totalValue },
            {
                params: { performChecks },
                pathParams: {
                    selectionListId
                }
            }
        )
        .then(res => res.data);
};
